import { FC } from 'react';
import { Label } from '../condition-label';

export interface IRenderBlock {
	label?: string | undefined;
	price: number;
}

export const RenderSignBlock: FC<IRenderBlock> = ({ label, price }) => {
	// Global variables

	// Local variables

	return (
		<>
			{/* Arun Kumar : For Sign Aggrement verification changed into Packet  */}
			<Label label={label || ''} price={price} priceLabel="Packet" />
			<div className="questions-wrapper"></div>
		</>
	);
};
